import type { ComponentType } from 'react';

import React from 'react';

/**
 * Wrap component with hook function with will be called in HOC component render
 */
const hoc = function <SP, HP>(
  hook: (props: SP) => HP,
  Source: ComponentType<HP & SP>
) {
  const Result: any = (props: SP) => (
    <Source {...(hook(props) || ({} as any))} {...props} />
  );

  Result.Original = Source;
  Result.hook = hook;

  return Result as any as ComponentType<Partial<HP> & SP> & {
    Original: ComponentType<HP & SP>;
    hook: typeof hook;
  };
};

export { hoc };
